import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from '../../../../shared/alert/alert.service';
import { AppService } from '../../../../../app.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  isPasswordVisible = false;
  isPasswordVisibleConfirm = false;

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  togglePasswordVisibilityConfirm() {
    this.isPasswordVisibleConfirm = !this.isPasswordVisibleConfirm;
  }

  resetForm: FormGroup
  email: any
  constructor(public fb: FormBuilder, public alertService: AlertService, public commonService: AppService, public router: Router) {
    this.resetForm = this.fb.group(
      {
        newPassword: ['', [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['', Validators.required],
      },
      {
        validators: this.passwordsMatchValidator,
      }
    );
    this.email = this.commonService.getEmail();
  }
  passwordsMatchValidator(formGroup: AbstractControl) {
    const password = formGroup.get('newPassword')?.value;
    const confirmPassword = formGroup.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { mismatch: true };
  }


  // onSubmit() {
  //   if (this.resetForm.valid) {
  //     let url = 'api/Auth/resetPassword'
  //     let payload = {
  //       email: this.email,
  //       newPassword: this.resetForm.controls['newPassword'].value
  //     }
  //     this.commonService.post(url, payload).subscribe({
  //       next: res => {
  //         this.alertService.success('Password Changed Successfully')
  //         this.router.navigate(['/login'])
  //       },
  //       error: (err: any) => {
  //         this.alertService.error('Password does not matches');
  //       }
  //     })
  //   }

  // }
  submitted = false;


  onSubmit() {

    this.submitted = true;
    if (this.resetForm.invalid) {
      this.resetForm.markAllAsTouched();
      if (this.resetForm.errors?.mismatch) {
        this.alertService.error('Passwords do not match');
      }
      return;
    }
  
    const url = 'api/Auth/resetPassword';
    const payload = {
      email: this.email,
      newPassword: this.resetForm.controls['newPassword'].value,
    };
    this.commonService.post(url, payload).subscribe({
      next: res => {
        this.alertService.success('Password Changed Successfully');
        this.router.navigate(['/login']);
      },
      error: err => {
        this.alertService.error('Something went wrong');
      },
    });
  }
  
}
